// import Swiper from 'swiper';
const TerminalMapRoutes = {
    init() {
        // JavaScript to be fired on the home page
        this._jMapWrapper = $('.map-container');

        this._addEvents();
        this.finalize();
    },
    

    finalize() {
        this.initMap();
    },
    initMap() {
        var map = $('#terminalMapplicRoute').mapplic({
            source: '/wp-content/uploads/resources/assets/scripts/customjs/terminal-routes.json',
            sidebar: false,
            toggle: true,
            alphabetic: true,
            height: 800,
            developer: false,
            searchdescription: false,
            searcheverywhere: false,
            animations: true,
            hovertip: true,
            minimap: false,
            marker: 'hidden',
            fillcolor: false,
            fullscreen: true,
            thumbholder: true,
            maxscale: 3,
            routes: {
                opened: false,
                from: 'location-id',
                linecolor: '#8FB339',
                speed: 0.8,
            },
        }); 
           
        
           
    
        
          $(window).resize(function() {

            var windowSize = $(window).width();
                if (windowSize < 920) {
                    console.log('screen width is less than 920');
                    map.on('mapready', function(e,self) {
                        self.moveTo(0.5,0.35,self.scale+(self.scale*1.3),600);
                    });
                }else if(windowSize < 767){
                    console.log('screen width is less than 767');
                    map.on('mapready', function(e,self) {
                        self.moveTo(0.5,0.35,self.scale+(self.scale*1.3),600);
                    });

                }else{
                    map.on('mapready', function(e,self) {
                        self.moveTo(0.5,0.35,self.scale+(self.scale*0.1),600);
                    });

                }
           
        });
    },
    
    _addEvents() {
       
       
    },
};

export default TerminalMapRoutes;


// WEBPACK FOOTER //
// ./scripts/modules/termina-routes.js